<template>
  <div :class="isLoggedIn ? 'wrapper d-flex align-items-stretch route-'+$router.currentRoute.name : ''">
    <Header />
    <div id="content" :class="isLoggedIn ? 'side-nav-active' : ''">
      <router-view></router-view>
    </div>
    <div id="global-spinner" v-show="dataLoading">
      <b-spinner label="Loading"></b-spinner>
    </div>
  </div>
</template>
<script>
import Header from "@/csmworkflow/js/components/common/Header";
import { mapActions, mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters(['dataLoading', 'preferenceData']),
    isLoggedIn() {
        if (this.$router.currentRoute.name == 'dashboardMediaCalls'){
            return true;
        }else{
            return this.$store.getters.isLoggedIn;
        }
    }
  },
  components: {
    Header
  },
  methods: {
    ...mapActions(['fetchSystemSettings', 'fetchAllCompanies', 'fetchUserPermissions', 'fetchAlerts', 'fetchUserAlerts', 'fetchNotification', 'fetchUserProjectsCount', 'fetchAllProjects', 'getPreference']),
  },
  created(){
    
  },
  mounted() {
    if (this.$router.currentRoute.name != 'dashboardMediaCalls'){
      if(this.isLoggedIn) {
        if(!this.preferenceData) {
            this.getPreference()
        }
        if (!this.systemSettings) {
          this.fetchSystemSettings();
        }
        this.fetchAllCompanies();
        this.fetchUserPermissions();
        this.fetchUserProjectsCount();
        this.fetchAllProjects();
        

        // let that = this;
        // let loadingNotifications = setInterval(function() {
        //   that.fetchAlerts();
        // }, 5000)
      }
    }
  },
};
</script>
